import React, { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";

import pixelEvent from "../../../hooks/pixelEvent";
import download from "../../../assets/images/download.svg";

import "./TransactionRow.sass";

function TransactionRow({
  transactionId,
  name,
  type,
  status,
  date,
  amount,
  returns,
  localAmount,
  localCurrency,
}) {
  const [showOriginalPrice, setShowOriginalPrice] = useState(false);
  const url =
    process.env.NODE_ENV === "development"
      ? "http://pcappstore.loc/api/api.php"
      : "/api/api.php";

  const convertDate = (dateVal) => {
    let d = new Date(Number(dateVal * 1000));
    d = `${
      String(d.getMonth() + 1).length < 2
        ? `0${d.getMonth() + 1}`
        : d.getMonth() + 1
    }/${d.getDate()}/${d.getFullYear()}`;
    return d;
  };

  const transactionHandler = () => {
    if (
      type.toLowerCase() !== "refund" &&
      type.toLowerCase() !== "balance" &&
      status.toLowerCase() !== "decline" &&
      status.toLowerCase() !== "failed"
    ) {
      pixelEvent({
        evt_src: "acct",
        evt_action: "trans_details_click",
      });
      window.location.href = `${url}?c=accountStore&a=transactionInvoice&p[id]=${transactionId}`;
    }
  };

  const getStatus = useCallback((val) => {
    const key = val.toLowerCase();
    const obj = {
      new: "Pending",
      completed: "Approved",
      failed: "Declined",
      decline: "Declined",
      refund: "Refund",
    };
    if (!obj[key]) {
      return val;
    }
    return obj[key];
  }, []);

  const getType = useCallback((val) => {
    const key = val.toLowerCase();
    const obj = {
      balance: "Balance Deduction",
    };
    return obj[key] || val;
  }, []);

  const transactionStatus = useMemo(() => getStatus(status), [status]);
  const transactionType = useMemo(() => getType(type), [type]);

  return (
    <tr onClick={transactionHandler} className="transactionRow">
      <td className="col">{transactionId}</td>
      <td className="col col__description">
        <strong>{name}</strong>
      </td>
      <td className="col col__type">
        <strong>{transactionType}</strong>
      </td>
      <td
        className={`col col__status col__status--${transactionStatus.toLowerCase()}`}
      >
        {transactionStatus}
      </td>
      <td className="col">{convertDate(date)}</td>
      {localAmount && localCurrency ? (
        <td
          className="col col__amount-cell"
          onMouseEnter={() => {
            setShowOriginalPrice(true);
          }}
          onMouseLeave={() => {
            setShowOriginalPrice(false);
          }}
        >
          {showOriginalPrice ? (
            <>{amount} USD</>
          ) : (
            <>
              {localAmount} {localCurrency}
            </>
          )}
        </td>
      ) : type.toLowerCase() === "refund" && returns > 0 ? (
        <td className="col col__amount-cell">$ {returns}</td>
      ) : (
        <td className="col col__amount-cell">$ {amount}</td>
      )}

      <td className="col">
        {type.toLowerCase() !== "refund" &&
        type.toLowerCase() !== "balance" &&
        status.toLowerCase() !== "decline" &&
        status.toLowerCase() !== "failed" ? (
          <div className="col col__link">
            <span>
              <img src={download} alt="Download" />
            </span>
            Invoice
          </div>
        ) : null}
      </td>
    </tr>
  );
}

TransactionRow.propTypes = {
  transactionId: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.string,
  date: PropTypes.string,
  amount: PropTypes.string,
  returns: PropTypes.number,
  localAmount: PropTypes.string,
  localCurrency: PropTypes.string,
};

TransactionRow.defaultProps = {
  transactionId: "",
  name: "",
  type: "",
  status: "",
  date: "",
  amount: "",
  returns: 0,
  localAmount: null,
  localCurrency: null,
};

export default TransactionRow;
